import "@zenlayer/zen-design/esm/tooltip/style";
import _Tooltip from "@zenlayer/zen-design/esm/tooltip";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import "@zenlayer/zen-design/esm/button/style";
import _Button from "@zenlayer/zen-design/esm/button";
import "@zenlayer/zen-design/esm/icon/style";
import _Icon from "@zenlayer/zen-design/esm/icon";
import _generalSync from "@zenlayer/zen-design-icons/assets/general/Sync.svg";
import React from 'react';
import t from '@zenlayer/zen-intl18';
/**
 * 刷新按钮组件
 * props参照ButtonProps
 * @example
 * <RefreshButton
 *   loading={loading || pollingLoading}
 *   onClick={refresh}
 * />
 */

import { jsx as _jsx } from "react/jsx-runtime";

var RefreshButton = function RefreshButton(props) {
  return /*#__PURE__*/_jsx(_Tooltip, {
    title: t('-AwbRkh9H6G4'),
    children: /*#__PURE__*/_jsx(_Button, _objectSpread({
      type: "normal",
      icon: /*#__PURE__*/_jsx(_Icon, {
        type: "general/Sync"
      }),
      size: "s"
    }, props))
  });
};

export default RefreshButton;